const MasterDataStoreState = {
  isLoading: false,
  masterData: {
    id: null,
    systemId: null,
    access: '',
    safetyBriefing: '',
    hazardNotes: '',
  },
  files: [],
};

export default MasterDataStoreState;
